import { numberBitGetByPosition } from "@smp/utils";

import { useEpBillingRecurringPaymentList } from "@/hooks/use_ep_billing_recurring_payment";
import { useContextApp } from "@/screens/app/context/app";

import { Classic } from "./classic";
import { Free2022 } from "./free_2022";
import { Polotno } from "./polotno";
import { Recurring } from "./recurring";
import { World } from "./world";

export const ControlsBilling = () => {
  const {
    state: { me, planActive, planLast },
  } = useContextApp();

  const { recurringPaymentList } = useEpBillingRecurringPaymentList({
    req: { query: { ordering: "-created_at" } },
  });

  const recurringPaymentActive = recurringPaymentList?.find(
    (recurringPayment) =>
      numberBitGetByPosition(recurringPayment.status, 1) === 1 &&
      numberBitGetByPosition(recurringPayment.status, 2) === 0,
  );

  if (planActive?.id === "canvas_2023") {
    return <Polotno />;
  }

  if (planActive?.id === "free_2022") {
    return <Free2022 />;
  }

  if (me.billing_policy_base === "classic") {
    return <Classic />;
  }

  if (!!recurringPaymentActive) {
    return <Recurring />;
  }

  if (
    ["europe", "cis", "world"].includes(me.billing_policy_id) &&
    planLast?.id !== "free_foreign"
  ) {
    return <Recurring />;
  }

  return <World />;
};
